export const DST_PRODUCT_DETAIL_LABELS = {
    productRange: "Product Range",
    accessories: "Accessories",
    machines: "Machines",
    generalInformation: "General Information",
    specifications: "Specifications",
    beverages: "Beverages",
    dimensions: "Dimensions",
    artNr: "Art. Nr.",
    viewProduct: "View Product",
    total: "total",
    similarMachines: "Similar machines",
} as const;

export type DstProductDetailLabels = typeof DST_PRODUCT_DETAIL_LABELS;
